var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.657,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#31a0df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#037cc2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-SL"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SL",
    clipPath: "url(#clip-SL)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1971",
    "data-name": "Group 1971",
    transform: "translate(4.001 -10.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M20.564,16.056A7.32,7.32,0,1,1,15.388,18.2,7.32,7.32,0,0,1,20.564,16.056Zm9.142,11.16a.639.639,0,1,1,.8-1,16.008,16.008,0,0,1,3.868,4.495,15.843,15.843,0,0,1,1.951,5.58.642.642,0,1,1-1.27.186,14.543,14.543,0,0,0-1.79-5.123,14.729,14.729,0,0,0-3.557-4.138Zm-3.791,25.1a.641.641,0,0,1,.467,1.195,15.816,15.816,0,0,1-2.853.82,16,16,0,0,1-5.932,0,15.814,15.814,0,0,1-2.853-.82.641.641,0,0,1,.467-1.195,14.539,14.539,0,0,0,2.622.754,14.9,14.9,0,0,0,5.46,0A14.54,14.54,0,0,0,25.915,52.313ZM6.075,36.478a.642.642,0,1,1-1.27-.186,15.843,15.843,0,0,1,1.951-5.58,16.008,16.008,0,0,1,3.868-4.495.639.639,0,1,1,.8,1,14.728,14.728,0,0,0-3.557,4.138,14.543,14.543,0,0,0-1.79,5.123ZM1.014,50.03a7.312,7.312,0,0,0,9.925,2.645l.04-.021a7.315,7.315,0,0,0,2.709-9.941.638.638,0,0,0-.064-.111,7.312,7.312,0,0,0-9.907-2.655.641.641,0,0,0-.111.064A7.312,7.312,0,0,0,.95,49.919a.643.643,0,0,0,.064.111Zm39.13-.055v0a7.315,7.315,0,0,0-2.678-10h0a7.315,7.315,0,0,0-10,2.678h0v0a7.315,7.315,0,0,0,2.678,10h0a7.313,7.313,0,0,0,9.994-2.679Z",
    transform: "translate(0 0)",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSl);
export default __webpack_public_path__ + "static/media/SL.abf9426b.svg";
export { ForwardRef as ReactComponent };